import { synapse } from '@ublique/platform'

export const initialState = {
  unitOfMeasure: 'value',
  pageSize: 10,
  isEditable: false,
  table: {
    items: null,
    metadata: null
  },
  selection: {
    selectAll: false,
    excluded: {},
    included: {},
    count: 0,
    total: 0
  },
  compositionTable: {
    pageSize: 5,
    selectedRow: null
  }
}

export const userFeedbackStore = synapse.store(initialState)

export const reducers = {
  onChangeSelectAll: (updatedData, prevState) => ({
    ...prevState,
    selection: {
      ...prevState.selection,
      ...updatedData
    }
  }),
  onRowSelection: (updatedData, prevState) => ({
    ...prevState,
    selection: {
      ...prevState.selection,
      ...updatedData
    }
  }),
  onRowDetailSelection: (updatedData, prevState) => ({
    ...prevState,
    compositionTable: {
      ...prevState.compositionTable,
      selection: {
        ...prevState.compositionTable.selection,
        ...updatedData
      }
    }
  })
}

export const userSelectors = {
  getSelection: (state) => state.selection,
  getItems: (state) => state.table.items,
  getUom: (state) => state.unitOfMeasure,
  getDetailPageSize: (state) => state.compositionTable.pageSize,
  getSelectedRow: (state) => state.compositionTable.selectedRow,
  getIsEditable: (state) => state.isEditable
}

export default {
  userFeedback: userFeedbackStore
}
